import React, { useState } from "react";
import Logo from "../../assets/rxultimate.png";
import LoginImage from "../../assets/3836182.jpg";
import axios from "axios";
import { api_url } from "../../utils/data";
import { toast } from "react-toastify";
import { Link, useNavigate } from "react-router-dom";
import { RotatingLines } from "react-loader-spinner";
import { HiOutlineMail } from "react-icons/hi";
import { BsTelephone } from "react-icons/bs";
import { IoArrowBackOutline } from "react-icons/io5";

const ForgotPassword = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [recoveryMethod, setRecoveryMethod] = useState("email");
  const [recoveryData, setRecoveryData] = useState({
    email: "",
    phone: ""
  });

  const handleInputChange = (e) => {
    setRecoveryData({
      ...recoveryData,
      [e.target.name]: e.target.value,
    });
  };

  const handleRecoveryMethodChange = (method) => {
    setRecoveryMethod(method);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsLoading(true);

    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };

    const requestData = {
      recovery_method: recoveryMethod,
      [recoveryMethod]: recoveryData[recoveryMethod]
    };

    const body = JSON.stringify(requestData);

    axios
      .post(`${api_url}/accounts/reset-password/`, body, config)
      .then((response) => {
        toast.success("Password reset instructions sent successfully");
        setIsLoading(false);
        if(recoveryMethod == "phone" && response.data.token){
          navigate(`/verify-reset-code/${response.data.token}`);
        }else{
            navigate("/reset-password-sent",{
                state:{
                    method: recoveryMethod,
                    contact: recoveryMethod === "email" ? recoveryData.email : recoveryData.phone
                }
            })
        }
      })
      .catch((error) => {
        setIsLoading(false);
        if(error?.response?.status === 500){
            toast.error("An unexpected error occured.")
            return;
        }
        if (error?.response?.data) {
          for (const property in error.response.data) {
            if (property !== "detail") {
              toast.error(`${property}: ${error.response.data[property]}`);
            } else {
              toast.error(`${error.response.data[property]}`);
            }
          }
        } else {
          toast.error("An error occurred. Please try again later.");
        }
      });
  };

  return (
    <div className="min-h-screen w-full bg-white">
      <div className="flex flex-col md:flex-row h-full min-h-screen">
        {/* Form Section */}
        <div className="w-full md:w-1/2 flex items-center justify-center p-4 md:p-8 lg:p-12">
          <div className="w-full max-w-md">
            <form onSubmit={handleSubmit} className="w-full">
              <div className="mb-8">
                <div className="flex justify-center md:justify-start mb-8">
                  <img
                    src={Logo}
                    alt="rxultimate"
                    className="h-16 md:h-20 w-auto"
                  />
                </div>
                <div className="text-left">
                  <h3 className="text-xl md:text-2xl font-semibold text-[#526484] mb-2">
                    Reset Password
                  </h3>
                  <p className="text-[#526484] text-sm">
                    Enter your email address or phone number to receive password reset instructions.
                  </p>
                </div>
              </div>

              <div className="space-y-5">
                {/* Recovery Method Toggle */}
                <div className="flex rounded-lg overflow-hidden border border-[#dbdfea]">
                  <button
                    type="button"
                    className={`flex-1 py-3 px-2 flex items-center justify-center gap-2 transition-colors ${
                      recoveryMethod === "email"
                        ? "bg-blue-600 text-white"
                        : "bg-gray-100 text-gray-700 hover:bg-gray-200"
                    }`}
                    onClick={() => handleRecoveryMethodChange("email")}
                  >
                    <HiOutlineMail className="text-lg" />
                    <span className="font-medium">Email</span>
                  </button>
                  <button
                    type="button"
                    className={`flex-1 py-3 px-2 flex items-center justify-center gap-2 transition-colors ${
                      recoveryMethod === "phone"
                        ? "bg-blue-600 text-white"
                        : "bg-gray-100 text-gray-700 hover:bg-gray-200"
                    }`}
                    onClick={() => handleRecoveryMethodChange("phone")}
                  >
                    <BsTelephone className="text-lg" />
                    <span className="font-medium">Phone</span>
                  </button>
                </div>

                {/* Dynamic Input Field */}
                <div className="flex flex-col">
                  {recoveryMethod === "email" ? (
                    <>
                      <label
                        className="text-[#344357] font-medium text-sm mb-1.5"
                        htmlFor="email"
                      >
                        Email Address
                      </label>
                      <input
                        type="email"
                        className="py-3 px-4 text-base rounded-lg border border-[#dbdfea] focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all"
                        name="email"
                        id="email"
                        placeholder="Enter your email address"
                        value={recoveryData.email}
                        onChange={handleInputChange}
                        required
                      />
                    </>
                  ) : (
                    <>
                      <label
                        className="text-[#344357] font-medium text-sm mb-1.5"
                        htmlFor="phone"
                      >
                        Phone Number
                      </label>
                      <input
                        type="tel"
                        className="py-3 px-4 text-base rounded-lg border border-[#dbdfea] focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all"
                        name="phone"
                        id="phone"
                        placeholder="Enter your phone number"
                        value={recoveryData.phone}
                        onChange={handleInputChange}
                        required
                      />
                    </>
                  )}
                </div>

                <div className="pt-3">
                  {isLoading ? (
                    <div className="flex justify-center items-center py-2">
                      <RotatingLines
                        visible={true}
                        height="48"
                        width="48"
                        strokeColor="blue"
                        strokeWidth="5"
                        animationDuration="0.75"
                        ariaLabel="rotating-lines-loading"
                      />
                    </div>
                  ) : (
                    <button
                      type="submit"
                      className="w-full bg-blue-600 hover:bg-blue-700 text-white font-medium py-3 px-4 rounded-lg transition-colors"
                    >
                      Send Reset Instructions
                    </button>
                  )}
                </div>

                <div className="text-center pt-4">
                  <Link
                    to="/login"
                    className="inline-flex items-center text-blue-600 hover:text-blue-800 font-medium text-sm"
                  >
                    <IoArrowBackOutline className="mr-1" /> Back to Login
                  </Link>
                </div>
              </div>
            </form>
          </div>
        </div>

        {/* Image Section - Hidden on small screens */}
        <div className="hidden md:flex md:w-1/2 bg-[#f5f6fa] items-center justify-center">
          <img
            src={LoginImage}
            alt="Reset password illustration"
            className="w-4/5 max-w-lg object-contain"
          />
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;